"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const getUrls = baseUrl => {
  const getUrl = url => "".concat(baseUrl).concat(url);

  return {
    GET_DRAFT_VIDEOS: getUrl('/v1/user-videos?status=CREATED,RENDERING_FAILED'),
    GET_PUBLISH_VIDEOS: getUrl('/v1/user-videos?status=PUBLISHED,RENDERED'),
    DELETE_VIDEO: id => getUrl("/v1/user-videos/".concat(id)),
    DUPLICATE_VIDEO: id => getUrl("/v1/user-videos/duplicate/".concat(id))
  };
};

var _default = getUrls;
exports.default = _default;